module.exports = __webpack_public_path__ + "static/media/pinZloz.2d1f56aa.png";